@if (tips().length > 0) {
  <section
    class="overflow-hidden rounded-lg border border-greyscale-200 bg-white"
    data-reduction-tips
  >
    <h4>
      <button
        type="button"
        class="flex w-full items-center gap-2 border-primary-100 bg-primary-50 px-4 py-2.5 text-left text-paragraph-xs-reg font-semibold uppercase tracking-wider text-primary-600 hover:bg-primary-100"
        [class.border-b]="open()"
        [attr.aria-expanded]="open()"
        (click)="toggle()"
      >
        <lucide-icon name="lightbulb" [size]="14" />
        {{ "reductionTips.card.title" | transloco }}
        <span class="font-medium text-greyscale-600">
          · {{ labelKey() | transloco }}
        </span>
        <span
          class="ml-auto flex items-center gap-2 font-medium normal-case tracking-normal text-greyscale-600"
        >
          {{ "reductionTips.card.count" | transloco: { count: tips().length } }}
          <lucide-icon
            name="chevron-down"
            [size]="16"
            class="transition-transform"
            [class.rotate-180]="open()"
          />
        </span>
      </button>
    </h4>
    @if (open()) {
      <ul>
        @for (tip of tips(); track tip.id) {
          <li class="border-t border-greyscale-100 first:border-t-0">
            <app-reduction-tip-item [tip]="tip" />
          </li>
        }
      </ul>
    }
  </section>
}
